import {
  faLock,
  faPencilAlt,
  faTrash,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Table, TableColumn } from '@vadiun/react-components';
import { useVerifyAction } from '@vadiun/react-hooks-legacy';
import { ClientBusinessUserModel } from '../models/ClientBusinessUser';
import { BusinessClientUser } from './ClientBusinessUserCrudComponent';

interface Props {
  users: ClientBusinessUserModel[];
  delete: (id: number) => void;
  restore: (id: number) => void;
  changePassword: (x: ClientBusinessUserModel) => void;
  selectToEdit: (x: BusinessClientUser) => void;
  selectToUpdateCompany: (x: BusinessClientUser) => void;
}

export const ClientBusinessUserTable = (props: Props) => {
  const verifyAction = useVerifyAction();

  const columns: TableColumn<ClientBusinessUserModel>[] = [
    {
      name: 'email',
      label: 'Email',
      options: {
        filter: false,
        sort: true
      }
    },

    {
      name: 'name',
      label: 'Nombre',
      options: {
        filter: false,
        sort: true
      }
    },

    {
      name: 'isDeleted',
      label: 'Borrado',
      options: {
        display: false,
        filterOptions: {
          names: ['Si', 'No']
        },
        filterList: ['No'],
        customFilterListOptions: { render: (v) => `Borrado: ${v}` }
      }
    },
    {
      label: 'Acciones',
      name: 'id',
      options: {
        filter: false,
        customBodyRenderLite: (index: number) =>
          props.users[index].isDeleted ? (
            <Button onClick={() => props.restore(props.users[index].id)}>
              Restaurar
            </Button>
          ) : (
            <div style={{ display: 'flex' }}>
              <Button
                onClick={() =>
                  verifyAction({
                    title: 'Estas por eliminar un usuario!',
                    body: 'Esta accion va a eliminar el usuario. ¿Estas seguro?',
                    onAccept: () => props.delete(props.users[index].id)
                  })
                }
                shape="circle"
                color="red"
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
              <Button
                onClick={() => props.selectToEdit(props.users[index])}
                shape="circle"
                color="primary"
              >
                <FontAwesomeIcon icon={faPencilAlt} />
              </Button>
              <div title="Cambiar contraseña">
                <Button
                  onClick={() => props.changePassword(props.users[index])}
                  shape="circle"
                  color="primary"
                >
                  <FontAwesomeIcon icon={faLock} />
                </Button>
              </div>
              <div title="Cambiar usuario de empresa">
                <Button
                  onClick={() =>
                    props.selectToUpdateCompany(props.users[index])
                  }
                  shape="circle"
                  color="secondary"
                >
                  <FontAwesomeIcon icon={faUserTie} />
                </Button>
              </div>
            </div>
          )
      }
    }
  ];

  const data = props.users.map((x) => ({
    ...x,
    isDeleted: x.isDeleted ? 'Si' : 'No'
  }));

  return (
    <div className="w-full">
      <Table title={'Usuarios'} data={data} columns={columns} />
    </div>
  );
};
